import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { pageTitle } from '../../helpers/PageTitle';
import '../../sass/shortcode/Signinup.scss';
import '../../sass/shortcode/SigninBanner.scss';
import { BASE_URL } from "../../helpers/api";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

// 👁️ Password Icons
import {
  FaEye,
  FaEyeSlash,
  FaUserPlus,
  FaUserCircle,
  FaUser,
  FaEnvelope,
  FaLock,
  FaArrowRight,
} from "react-icons/fa";

export default function SignUp() {
  pageTitle('Sign Up');
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: 'patient',
    mobile: '',
    focusMobile: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [passwordHint, setPasswordHint] = useState("");

  // EMAIL VALIDATION
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // PASSWORD VALIDATION
  const isValidPassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isValidEmail(formData.email)) {
    alert("Please enter a valid email address.");
    return;
  }

  if (!isValidPassword(formData.password)) {
    alert(
      "Password must be at least 8 characters long and include:\n" +
      "- One uppercase letter\n" +
      "- One lowercase letter\n" +
      "- One number\n" +
      "- One special character"
    );
    return;
  }

  // const phoneNumber = parsePhoneNumberFromString("+" + formData.mobile);

  
  const rawNumber = formData.mobile.replace(/\s/g, "").startsWith("+")
  ? formData.mobile.replace(/\s/g, "")
  : "+" + formData.mobile.replace(/\s/g, "");

  const phoneNumber = parsePhoneNumberFromString(rawNumber);

  if (!phoneNumber || !phoneNumber.isValid()) {
    alert("Please enter a valid mobile number for the selected country.");
    return;
  }

  const { focusMobile, ...cleanData } = formData;

  const payload = {
    ...cleanData,
    mobile: phoneNumber.number,
  };

  try {
    const response = await axios.post(
      `${BASE_URL}/auth/signup`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.data.message) {
      alert("Registered successfully. Please login.");
      navigate('/signIn');
    } else {
      alert(response.data.error || "Registration failed");
    }
  } catch (error) {
    alert(error.response?.data?.error || "Registration failed. Please try again.");
  }
  };






  return (
    <>
      <section className="cs_signin_banner">
        <span className="cs_signin_dots" />
        <div className="container">
          <div className="cs_signin_banner_row">
            <div className="cs_signin_banner_left">
              <h1>Welcome to Medayus</h1>
              <span className="cs_signin_underline" />
              <p>
                Register to schedule appointments, access records, and get
                personalized care.
              </p>
              <a href="#signup-form" className="cs_signin_cta">
                <FaUserPlus /> Create Your Account
              </a>
            </div>
            <div className="cs_signin_banner_right">
              <img
                src="/images/signin_banner_illustration.png"
                alt="Sign up"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="signin-container" id="signup-form">
        <div className="signin-wrapper">

          {/* LEFT IMAGE */}
          <div className="signin-left">
            <img
              src="/images/auth-img.png"
              alt="Sign Up Illustration"
              className="signin-image"
            />
          </div>

          {/* RIGHT FORM */}
          <div className="signin-form">
            <span className="signin-form-icon">
              <FaUserCircle />
            </span>
            <h2 className="signin-title">Create Your Account</h2>
            <p className="signin-subtitle">Register to get started</p>

            <form onSubmit={handleSubmit}>

              {/* NAME */}
              <div className="form-group">
                <label>Full Name <span className="required">*</span></label>
                <div className="form-input-wrap">
                  <span className="form-input-icon">
                    <FaUser />
                  </span>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    required
                  />
                </div>
              </div>

              {/* EMAIL */}
              <div className="form-group">
                <label>Email <span className="required">*</span></label>
                <div className="form-input-wrap">
                  <span className="form-input-icon">
                    <FaEnvelope />
                  </span>
                  <input
                    type="email"
                    className="form-input"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    required
                  />
                </div>
              </div>

              {/* PASSWORD + EYE ICON */}
              <div className="form-group">
                <label>Password <span className="required">*</span></label>

                <div className="form-input-wrap">
                  <span className="form-input-icon">
                    <FaLock />
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-input"
                    placeholder="Enter your password"
                    value={formData.password}
                    onChange={(e) => {
                        const val = e.target.value;
                        setFormData({ ...formData, password: val });

                        if (!val) { setPasswordHint(""); return; }
                        if (val.length < 8)         { setPasswordHint("Too short – minimum 8 characters"); return; }
                        if (!/[A-Z]/.test(val))     { setPasswordHint("Add at least one uppercase letter"); return; }
                        if (!/[a-z]/.test(val))     { setPasswordHint("Add at least one lowercase letter"); return; }
                        if (!/\d/.test(val))        { setPasswordHint("Add at least one number"); return; }
                        if (!/[@$!%*?&]/.test(val)) { setPasswordHint("Add a special character (@$!%*?&)"); return; }
                        setPasswordHint("Password looks strong!");
                      }}
                    required
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                {/* PASSWORD HINT */}
                {passwordHint && (
                  <p style={{
                    fontSize: "12px",
                    marginTop: "6px",
                    color: passwordHint === "Password looks strong!" ? "green"
                          : passwordHint.startsWith("Too short") ? "red"
                          : "#e67e00"
                  }}>
                    {passwordHint}
                  </p>
                )}
              </div>

              {/* PHONE FIELD */}
              <div className="form-group">
                <label>Mobile Number <span className="required">*</span></label>

                <PhoneInput
                  country={"in"}
                  value={formData.mobile}
                  onChange={(value) =>
                    setFormData({ ...formData, mobile: value })
                  }
                  enableSearch={true}
                  placeholder="Enter your mobile number"
                  containerStyle={{
                    marginTop: "6px",
                    width: "100%",
                    fontFamily: "poppins, sans-serif",
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "48px",
                  }}
                  onFocus={() => setFormData({ ...formData, focusMobile: true })}
                  onBlur={() => setFormData({ ...formData, focusMobile: false })}
                />
              </div>

              {/* SUBMIT */}
              <button type="submit" className="submit-button">
                Register <FaArrowRight />
              </button>

              <div className="divider">
                <hr />
                <span>OR</span>
                <hr />
              </div>

              <p className="signup-link">
                Already have an account? <Link to="/signIn">Sign In</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
